import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InviteUserForm from './InviteUserForm';
import Modal from '../Common/Modal';
import { Button } from '../Common/button';
import { fetchAllUsers } from '../../services/userService';

// Définir une interface pour les utilisateurs pour la typage
interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

const UserManagement: React.FC = () => {
  const { t } = useTranslation();
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // État pour la modale

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const list = await fetchAllUsers();
        setUsers(list as unknown as User[]);
      } catch {
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-foreground">{t('settings.userManagementTitle')}</h2>
        <Button onClick={openModal}>{t('settings.addUser')}</Button>
      </div>

      <div className="overflow-x-auto rounded-xl border border-border bg-card">
        <table className="min-w-full">
          <thead className="bg-muted/50">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {t('settings.name')}
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {t('settings.email')}
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {t('settings.role')}
              </th>
              <th scope="col" className="relative px-6 py-3">
                <span className="sr-only">{t('settings.actions')}</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {loading ? (
              <tr><td className="px-6 py-4 text-sm text-muted-foreground" colSpan={4}>{t('settings.loading')}</td></tr>
            ) : users.map((user: User) => (
              <tr key={user.id} className="hover:bg-muted/30">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-foreground">{user.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground/80">{user.email}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground/80">{user.role}</td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <Button variant="ghost" className="text-primary mr-2">{t('settings.edit')}</Button>
                  <Button variant="ghost" className="text-destructive">{t('settings.delete')}</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal open={isModalOpen} onClose={closeModal} title={t('settings.inviteCollaborator')}>
        <InviteUserForm />
      </Modal>

    </div>
  );
};

export default UserManagement;
